"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExplorers = void 0;
const networks_1 = __importDefault(require("./networks"));
const getExplorers = (input, inputType, networkKey) => {
    const network = networks_1.default[networkKey];
    if (!network) {
        throw new Error("Network not found");
    }
    if (!("apps" in network) || !Array.isArray(network.apps)) {
        throw new Error("Explorers not available for the provided network");
    }
    const explorerApps = network.apps.filter((app) => app.type === "explorer");
    const urls = [];
    for (const app of explorerApps) {
        if (inputType === "address" && app.address) {
            urls.push(app.url + app.address.replace("${address}", input));
        }
        else if (inputType === "tx" && app.tx) {
            urls.push(app.url + app.tx.replace("${tx}", input));
        }
    }
    return urls;
};
exports.getExplorers = getExplorers;
